import { Call } from "@twilio/voice-sdk";
import { SellerAdminChatContact } from "../types";

export type VoiceCallDisplay = {
  identity: string;
  name: string;
  photoUrl: string | null;
};

export type VoiceCallTarget = {
  identity: string;
  name: string;
  photoUrl?: string | null;
};

export function buildVoiceConnectParams(
  target: VoiceCallTarget,
  caller: VoiceCallDisplay,
) {
  const params: Record<string, string> = {
    CalleeIdentity: target.identity,
    CallerName: caller.name,
  };

  if (caller.photoUrl) {
    params.CallerPhoto = caller.photoUrl;
  }

  return params;
}

export function resolveVoiceCallDisplay(
  identity: string,
  customParameters: Map<string, string> | undefined,
  contacts: SellerAdminChatContact[],
  fallbackLabel = "Contato",
): VoiceCallDisplay {
  const normalizedIdentity = identity.replace(/^client:/, "");
  const callerName = customParameters?.get("CallerName") ?? "";
  const callerPhoto = customParameters?.get("CallerPhoto") ?? null;
  const contact = contacts.find(
    (item) => item.call_identity === normalizedIdentity,
  );

  return {
    identity: normalizedIdentity,
    name: callerName || contact?.name || fallbackLabel,
    photoUrl: callerPhoto || contact?.photo_url || null,
  };
}

export function resolveIncomingCallDisplay(
  call: Call,
  contacts: SellerAdminChatContact[],
): VoiceCallDisplay {
  const identity = (call.parameters?.From ?? "").replace(/^client:/, "");
  const fallbackLabel = identity.startsWith("admin_") ? "Administrador" : "Vendedor";

  return resolveVoiceCallDisplay(
    identity,
    call.customParameters,
    contacts,
    fallbackLabel,
  );
}

export function getVoiceInitials(name: string) {
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");
}
